module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-c636d96c96b829d80f409a958a9c2ebd.png";